import React, {useEffect, useState} from 'react';
import {
  usuarioEditDuck,
  usuarioEditThunk,
  usuarioGetDuck,
  usuarioGetThunk,
} from './duck';
import {useSelector, useDispatch} from 'react-redux';
import {constants, responseSelector, validateEmail} from '../utils/utils';
import {alertTypes} from '../utils/Alert';
import {UsuarioEditView} from './UsuarioEditView';
import {documentTypeOptions, rolOptions} from '../utils/constants';

function UsuarioEdit({token, history, match}) {
  const credencialId = match.params.credencialId;

  const alertDefaultValue = {
    text: null,
    type: null,
    title: null,
    closable: false,
  };
  const [topAlert, setTopAlert] = useState(alertDefaultValue);

  const [submitAlert, setSubmitAlert] = useState(alertDefaultValue);
  const dispatch = useDispatch();

  const usuarioGet = useSelector(state => state.usuarioGet);
  const usuarioEdit = useSelector(state => state.usuarioEdit);

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [nombre, setNombre] = useState(null);
  const [apellido, setApellido] = useState(null);
  const [rolOption, setRolOption] = useState(null);
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [tel, setTel] = useState('+595');
  const [documento, setDocumento] = useState('');
  const [estadoOption, setEstadoOption] = useState(null);

  const [documentType, setDocumentType] = useState({
    value: 'CI',
    label: 'Cedula de identidad',
  });

  useEffect(() => {
    dispatch(
      usuarioGetThunk({
        userToken: token.raw,
        credencialId,
      }),
    );
  }, []);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(usuarioGet);

    if (error) {
      setSubmitAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });
      dispatch(usuarioGetDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      console.log('data', data);

      setNombre(data.nombre);
      setApellido(data.apellido);
      setEstadoOption(
        data.activo
          ? {value: true, label: 'Activo'}
          : {value: false, label: 'Inactivo'},
      );
      setRolOption(rolOptions.find(r => r.value === data.rol));
      setDocumento(data.document);
      setDocumentType(
        documentTypeOptions.find(d => d.value === data.documentType),
      );
      setTel(data.phoneNumber);

      dispatch(usuarioGetDuck.actions.clear());
    }
  }, [usuarioGet]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(usuarioEdit);

    if (error) {
      setSubmitAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });
      dispatch(usuarioEditDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      history.goBack();
      dispatch(usuarioEditDuck.actions.clear());
    }
  }, [usuarioEdit]);

  function submit() {
    if (!nombre) {
      setSubmitAlert({
        title: 'Error',
        text: 'Por favor complete todos los campos',
        type: alertTypes.danger,
        closable: false,
      });
      return;
    }
    console.log({rolOption});
    const data = {
      credentialID: credencialId,
      nombre,
      email: username,
      document: documento,
      documentType: documentType?.value,
      phoneNumber: tel === '+595' ? null : tel,
      estado: estadoOption?.value,
      rol: rolOption?.value,
      address: {
        direccion: '',
        lat,
        lng,
      },
      userToken: token.raw,
    };

    console.log({data});

    dispatch(usuarioEditThunk(data));
  }

  return (
    <UsuarioEditView
      mode="edit"
      usuarioEdit={usuarioEdit}
      submit={submit}
      topAlert={topAlert}
      rolOption={rolOption}
      setRolOption={setRolOption}
      nombre={nombre}
      setNombre={setNombre}
      apellido={apellido}
      setApellido={setApellido}
      username={username}
      setUsername={setUsername}
      password={password}
      setPassword={setPassword}
      documentType={documentType}
      setDocumentType={setDocumentType}
      documento={documento}
      setDocumento={setDocumento}
      tel={tel}
      setTel={setTel}
      submitAlert={submitAlert}
      estadoOption={estadoOption}
      setEstadoOption={setEstadoOption}
      history={history}
      token={token}
    />
  );
}

export {UsuarioEdit};
